import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common'
import { Component, DestroyRef, Inject, inject, OnInit } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatTabsModule } from '@angular/material/tabs'

@Component({
  selector: 'iho-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatTabsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatButtonToggleModule,
]
})

export class PrivacyPolicyComponent implements OnInit {
  listBreadcrumb: any;
  constructor( ) {
  }
  ngOnInit(): void {
    this.listBreadcrumb = [
      {
        "@id": "/",
        "name": "رزرو هتل"
      },
      {
        "@id": "#",
        "name": "حریم شخصی"
      }
    ]
  
}



}
